const  Constants = { 
  UNDERSCORE_DELIMITER : "___",
  DYNAMIC_CONTENT_START_DELIMITER : "___DYNAMIC_CONTENT",
  DYNAMIC_CONTENT_END_DELIMITER : "DYNAMIC_CONTENT___",
  FIELD_MERGE_REGEX : /___FIELD_MERGE(.*?)FIELD_MERGE___/gi,
  DYNAMIC_CONTENT_REGEX : /___DYNAMIC_CONTENT(.*?)DYNAMIC_CONTENT___/gi,    
  FIELD_MERGE_START_DELIMITER : "___FIELD_MERGE",
  FIELD_MERGE_END_DELIMITER : "FIELD_MERGE___",
  SOURCE_PREVIEW_BUNDLE: "Source Offline Preview (.zip)",
  TARGET_PREVIEW_BUNDLE: "Target Offline Preview (.zip)", 
  ESCAPE : "Escape",
  TAB: 'Tab',
  ENTER: 'Enter',
  CLICK: 'click',
  STANDARD:"STANDARD",
}
export default Constants;

